export const FETCH_SEO_PAGES = 'FETCH_SEO_PAGES';
export const DELETE_SEO_PAGES = 'DELETE_SEO_PAGES';